import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import navigation from '../../Content/Data/Navigation/navigation.json';
import AmatyaConsultantsLogo from '../../Content/Images/Logo.png';

function SideNavbar(props) {

    const [arrNavigation, setNavigation] = useState(getNavigationJson());
    const nodeRef = useRef([]);

    useEffect(() => {
        setNavigation(getNavigationJson());
    }, [props.isPathChanged])

    function getNavigationJson() {
        return navigation.map(x => {
            if (x.subMenu && x.subMenu.length > 0) {
                let isSeleted = false;
                let arrSubMenu = x.subMenu.map(y => {
                    if (y.subMenu && y.subMenu.length > 0) {
                        let isSubMenuSeleted = false;
                        let arrSubMenu2 = y.subMenu.map(z => {
                            if (!isSubMenuSeleted) {
                                isSubMenuSeleted = isActiveByDefault(z, y, x);
                            }
                            if (!isSeleted) {
                                isSeleted = isSubMenuSeleted;
                            }
                            return {
                                ...z,
                                "isSelected": isActiveByDefault(z, y, x)
                            };
                        });
                        return {
                            ...y,
                            "subMenu": arrSubMenu2,
                            "isSelected": isSubMenuSeleted
                        };
                    }
                    else {
                        if (!isSeleted) {
                            isSeleted = isActiveByDefault(y, x);
                        }
                        return {
                            ...y,
                            "isSelected": isActiveByDefault(y, x)
                        };
                    }
                });
                return {
                    ...x,
                    "subMenu": arrSubMenu,
                    "isSelected": isSeleted
                };
            }
            else {
                return {
                    ...x,
                    "isSelected": isActiveByDefault(x)
                };
            }
        });
    }

    function handleNavclick(item) {
        let arrData = arrNavigation.map(x => {
            if (x.subMenu && x.subMenu.length > 0) {
                let isSeleted = false;
                let arrSubMenu = x.subMenu.map(y => {
                    if (y.subMenu && y.subMenu.length > 0) {
                        let isSubMenuSeleted = false;
                        let arrSubMenu2 = y.subMenu.map(z => {
                            if (!isSubMenuSeleted) {
                                isSubMenuSeleted = z.id === item.id;
                            }
                            if (!isSeleted) {
                                isSeleted = isSubMenuSeleted;
                            }
                            return {
                                ...z,
                                "isSelected": z.id === item.id
                            };
                        });
                        return {
                            ...y,
                            "subMenu": arrSubMenu2,
                            "isSelected": isSubMenuSeleted
                        };
                    }
                    else {
                        if (!isSeleted) {
                            isSeleted = y.id === item.id;
                        }
                        return {
                            ...y,
                            "isSelected": y.id === item.id
                        };
                    }
                });
                return {
                    ...x,
                    "subMenu": arrSubMenu,
                    "isSelected": isSeleted
                };
            }
            else {
                return {
                    ...x,
                    "isSelected": x.id === item.id
                };
            }
        });
        nodeRef.current.map(x => { x.style.display = "none" });
        nodeRef.current = [];
        setNavigation(arrData);
        props.setIsPathChanged(!props.isPathChanged);
        props.setOpenSideNavigation(!props.openSideNavigation)
    }

    function isActiveByDefault(z, y, x) {
        let location = "/" + z.to;
        if (y) {
            location = "/" + y.to + "?a=" + z.to;
        }
        if (x) {
            location = "/" + x.to + "?a=" + y.to + "&b=" + z.to;
        }
        if (document.location.pathname + document.location.search === location) {
            return 1;
        }
        return 0;
    }

    function handleTouchEvent(event) {
        let node;
        if (event.target.className.includes('fa-caret')) {
            node = event.target.parentElement;
        }
        else if (event.target.className.includes('nav-dropdown')) {
            node = event.target.firstChild;
        }
        else {
            node = event.target;
        }
        nodeRef.current.push(node.nextSibling);
        node.nextSibling.style.display = "flex";
        console.log(node);
    }

    return (
        <div className="side-nav-container">
            <div className={props.openSideNavigation ? "side-nav side-nav-show" : "side-nav"}>
                <div className='flex'>
                    <div className='side-nav-brand'>
                        <img src={AmatyaConsultantsLogo} alt='AmatyaConsultants'></img>
                    </div>
                    <div className='side-nav-ham'>
                        <button className='side-nav-ham-btn' onClick={() => { props.setOpenSideNavigation(!props.openSideNavigation) }}>
                            <i className="fa fa-bars"></i>
                        </button>
                    </div>
                </div>
                {
                    arrNavigation.map((x, i) => {
                        if (x.subMenu && x.subMenu.length > 0) {
                            return (
                                <div key={i} id={x.id}>
                                    <div className="side-nav-dropdown">
                                        <button
                                            className={x.isSelected ? 'side-' + x.className + ' side-nav-dropbtn active-side-nav' : 'side-' + x.className + ' side-nav-dropbtn'}
                                            onTouchStart={(event) => { handleTouchEvent(event); }}
                                        >
                                            {x.name}
                                            &nbsp; <i className="fa fa-caret-down"></i>
                                        </button>
                                        <div className="side-nav-dropdown-content">
                                            {
                                                x.subMenu.map((y, j) => {
                                                    if (y.subMenu && y.subMenu.length > 0) {
                                                        return (
                                                            <div key={j} id={y.id}>
                                                                <div className="side-sub-nav-dropdown">
                                                                    <button
                                                                        className={y.isSelected ? 'side-sub-nav-dropbtn active-side-nav' : 'side-sub-nav-dropbtn'}
                                                                        onTouchStart={(event) => { handleTouchEvent(event); }}
                                                                    >
                                                                        {y.name}
                                                                        &nbsp; <i className="fa fa-caret-down"></i>
                                                                    </button>
                                                                    <div className="side-sub-nav-dropdown-content">
                                                                        {
                                                                            y.subMenu.map((z, k) => {
                                                                                return (
                                                                                    <Link key={k} id={z.id} className={z.isSelected ? 'side-' + z.className + ' active-side-nav-drop-link' : 'side-' + z.className} onClick={(event) => { handleNavclick(z) }} to={"/" + x.to + "?a=" + y.to + "&b=" + z.to}>{z.name}</Link>
                                                                                )
                                                                            })
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                    else {
                                                        return (
                                                            <Link key={j} id={y.id} className={y.isSelected ? 'side-' + y.className + ' active-side-nav-drop-link' : 'side-' + y.className} onClick={(event) => { handleNavclick(y) }} to={"/" + x.to + "?a=" + y.to}>{y.name}</Link>
                                                        );
                                                    }
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            );
                        }
                        else {
                            return (
                                <Link key={i} id={x.id} className={x.isSelected ? 'side-' + x.className + ' active-side-nav' : 'side-' + x.className} onClick={(event) => { handleNavclick(x) }} to={"/" + x.to}>{x.name}</Link>
                            );
                        }
                    })
                }
            </div>
        </div>
    );
}

export default SideNavbar;
